import React, { Component } from 'react';
import { cloneDeep } from 'Utils/lodashUtils';
import classnames from 'classnames';
import counterpart from 'counterpart';
import ImageToolkit from 'Components/ImageToolkit';
import { Redirect } from 'react-router-dom';
import ImageSearchResults from 'Components/ImageSearchResults/ImageSearchResults';
import ImageSearchResultAssignmentSummary from 'Components/ImageSearchResultAssignmentSummary/ImageSearchResultAssignmentSummary';
import ImageData from 'Components/ImageData/ImageData';
import ResponseBanner from 'Components/cards/ResponseBanner';
import GDFilterPane from 'Components/GDReportRunner/GDFilterPane/GDFilterPane';
import tabArrow from 'Assets/img/tab-arrow.svg';
import EditableInput from 'Components/forms/EditableInput';
import moment from 'moment';
import SelectInput from 'Components/forms/select-input';
import {
  getSchemeImageData, getMerchantImageData, getImageContent, postArchiveImage,
  postFilterImageValues, attachImage,attachAndArchiveImage, undoAttachImage, checkIfLocked,
  getDocumentTypeUrl
} from 'Apis/caseDataAPI.js';
import { getAcquirerAccessList } from 'Utils/permissionsUtils';
import { getFilterTranslations } from '../AppSearch/configFilterStructure';
import { archiveImage, initializeImageSelection } from '../../actions/imageSelectionAction';
import { connect } from 'react-redux';
import { getToken } from 'Apis/tokenizeFilterElement';
import {
  openDocumentInNewTab,
} from 'Utils/appendImageUtil.js';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import OpenNewWindowIcon from 'Components/icons/OpenNewWindowIcon/OpenNewWindowIcon.jsx';
import DownloadIcon from 'Components/icons/download-icon/DownloadIcon.jsx';

import fileSaver from 'file-saver';
import { apiDownloadDocument } from 'Apis/imageReaderApi';
import { openNotificationToast } from 'Utils/notificationMessageUtils.jsx';
import EmptyState from 'Components/EmptyState/EmptyState';
import ChangingProgressProvider from "Components/ChangingProgressProvider/ChangingProgressProvider.js";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { gotoNewTabCaseLandingPage } from 'Utils/newTabUtils.jsx';

import './ImageSelection.scss';
import ImagePortal from '../ImagePortal/ImagePortal';
import LinkInlineButton from 'Components/Button/LinkInlineButton';
import LeftPointerIcon from 'Components/icons/left-pointer-icon/LeftPointerIcon';
import { VITE_SCHEME_IMAGE_QUEUE, VITE_MERCHANT_IMAGE_QUEUE, VITE_LOCK_CASE_TIME_INTERVAL } from 'Constants/appEnvConstants';

import {
  postLockImage,
  unlockImage,
} from 'Apis/queueManagerApi.js';
import {
  setLockedImageCount,
  setLockedImages,
  getLockedImageCount,
  checkImageIsPresent,
  removeLockedImages,
} from 'Utils/localStorageUtils.js';
import { isUserAuthenticatedSelector } from '../../selectors';
import LockIcon from 'Assets/img/landingpage-lock.svg';
import { flushSync } from 'react-dom';
import { COLORS } from "Constants/BIDashboardConstants";

const FILTER_API_MAPPING = {
  acqRefNumber: 'acqReferenceNumber',
  caseNumber: 'caseNumber',
  cardBrandCaseNumber: 'cardBrandCaseNumber',
  merchant_number: 'merchantNumber',
  transactionAmount: 'transactionAmount',
  transactionCode: 'transactionCode',
  transactionDate: 'fromDate',
  transactionDate: 'toDate',
  accountNumber: 'accountNumber',

};

const ocrMapping = [
  {
    ocrValue: 'Case Number',
    mapValue: 'caseNumber',
  },
  {
    ocrValue: 'CaseNumber',
    mapValue: 'caseNumber',
  },
  {
    ocrValue: 'CASE',
    mapValue: 'caseNumber',
  },
  {
    ocrValue: 'case',
    mapValue: 'caseNumber',
  },
  {
    ocrValue: 'Transaction Code',
    mapValue: 'transactionCode',
  },
  /* {
    ocrValue: 'Account Number',
    mapValue: 'accountNumber',
  }, */
  {
    ocrValue: 'Transaction Amount',
    mapValue: 'disputeAmount',
  },
  {
    ocrValue: 'Merchant Number',
    mapValue: 'merchantNumber',
  },
  {
    ocrValue: 'ARN',
    mapValue: 'acquirerReferenceNumber',
  },
  /* {
    ocrValue: 'Card Number',
    mapValue: 'maskedCardNumber',
  }, */
  /* {
    ocrValue: 'Transaction Date',
    mapValue: 'transactionDate',
  }, */
];

export class ImageSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addClass: false,
      selectedPages: [],
      selectAllFlag: false,
      isFilterVisible: false,
      readOnlyCurrentValues: [],
      currentValues: [],
      attachAndArchive:[],
      summaryData: [],
      isAssignPages: false,
      isLoading: false,
      isLoad:false,
      imageContentsErr: false,
      selectedIndex: 0,
      actionValue: '',
      data: {},
      bannerResponseMessage: '',
      isAttachStarted: false,
      showCaseLockedMessage: false,
      updatedPageList: [],
      imageContents: [],
      downloadInProgress: false,
      emptyStateHeading: 'Image not available.',
      emptyStateDescription: 'Please try again later.',
      currentSelectedImageIndex: 0,
      updatedSummaryData: [],
      documentTypes: [],
      isReadOnly: false,
      isZoomReset:false,
      attachAndArchiveList: [],
    };    
    this.attachBindings();
  }
  componentWillMount() {
    if (this.props.location.state !== undefined) {
      if (this.props.location.state.queueId === VITE_SCHEME_IMAGE_QUEUE || this.props.location.state.queueId === VITE_MERCHANT_IMAGE_QUEUE) {
        this.setState({
          isImageDataLoading: true,
        })
        this.getImageContent(this.props.location.state.data.documentDirectoryPath, this.props.location.state.data.documentName);
      }

      if (this.props.location.state.queueId === VITE_SCHEME_IMAGE_QUEUE) {
        this.setState({
          isImageDataLoading: true,
        })
        this.fetchSchemeImageData(this.props.location.state.data.documentId);
      } else if (this.props.location.state.queueId === VITE_MERCHANT_IMAGE_QUEUE) {
        this.setState({
          isImageDataLoading: true,
        })
        this.fetchMerchantImageData(this.props.location.state.data.documentName);
      }

      if (this.props.location.state.queueId === VITE_MERCHANT_IMAGE_QUEUE) {
        this.fetchDocumentLabel('UM');
      }
      else if (this.props.location.state.queueId === VITE_SCHEME_IMAGE_QUEUE) {
        this.fetchDocumentLabel('US');
      }
    }

    this.setState({
      selectList: getSelectionList(),
    });
  }

  componentDidMount() {    
    window.addEventListener('unload', (ev) => {
      ev.preventDefault();
      // navigator.sendBeacon(this.unlockCurrentImage());
    });
    window.addEventListener('beforeunload', this.removeCurrentLockedImage);
      let intervalTiming = setInterval(this.updateCurrentImageTimeStamp, VITE_LOCK_CASE_TIME_INTERVAL);
      this.setState({
        intervalTiming,
      });
  }

  componentDidUpdate() {
    if (this.props.imageSelection.archiveResponse.statusCode && 
      this.props.imageSelection.archiveResponse.statusCode === 2000) {
      const archiveData = {
        bannerResponseMessage: 'has been successfully archived',
        isDataUploaded: true,
        isError: false,
        isVisible: false,
      };
      this.goToImageLanding();
      this.setArchiveImageBanner(archiveData);
      this.props.initializeImageSelection();
    }
    else if(this.props.imageSelection.error) {
      this.setState({
        archiveImageFailBanner: true,
      });
      this.props.initializeImageSelection();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.removeCurrentLockedImage);
    this.state.intervalTiming && clearInterval(this.state.intervalTiming);
    this.setState({ summaryData: [] });
  }

  undoImageLinking() {
    this.closeBanner();
    undoAttachImage(this.state.attachList)
      .then(() => {
        this.setState({
          showUndoSuccessBanner: true,
          showUndoErrorBanner: false,
        });
      })
      .catch(() => {
        this.setState({
          showUndoSuccessBanner: false,
          showUndoErrorBanner: true,
        });
      });
  }

  fetchSchemeImageData(documentId) {
    getSchemeImageData(documentId)
      .then((apiResponse) => {
        const currentValues = this.prepopulateImageDate(apiResponse.data);
        this.setState({
          readOnlyCurrentValues: JSON.parse(JSON.stringify(currentValues)),
          currentValues,
          isImageDataLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          currentValues: [],
          isImageDataLoading: false,
        });
      });
  }

  prepopulateImageDate(rowData) {
    const currentValues = [];
    const filterList = this.props.location.state.imageSelectionConfig.searchFilters;

    filterList.map((filter) => {
      if (rowData != undefined) {
        let currentData;
        rowData.map((data) => {
          if (Object.keys(data)[0] == filter.columnKey) {
            currentData = data[Object.keys(data)[0]];
          }
        })

        if (currentData != undefined) {
          let newValue;
          /* if(filter.columnKey == 'transactionDate'){
            newValue = Object.assign({}, {
              [filter.reportFilterId]: { v1: currentData, v2: currentData },
            });
          }else{ */
          newValue = Object.assign({}, {
            [filter.reportFilterId]: { v1: currentData },
          });
          //}
          currentValues.push(newValue);
        }
      }
    });
    return currentValues;
  }

  fetchMerchantImageData(documentName) {
    getMerchantImageData(documentName)
      .then((apiResponse) => {
        const mappedJson = this.convertOcrMapping(apiResponse.data);
        const currentValues = this.prepopulateImageDate(mappedJson);
        this.setState({
          readOnlyCurrentValues: JSON.parse(JSON.stringify(currentValues)),
          currentValues,
          isImageDataLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          currentValues: [],
          isImageDataLoading: false,

        });
      });
  }

  convertOcrMapping(responseData) {
    const mappedArray = [];
    ocrMapping.map((mapping) => {
      if (responseData !== undefined) {
        const value = responseData[`${mapping.ocrValue}`];
        if (value !== undefined) {
          const newValue = Object.assign({
            [`${mapping.mapValue}`]: value,
          });
          mappedArray.push(newValue);
        }
      }
    });
    return mappedArray;
  }

  attachBindings() {
    this.goToCaseLandingPageByCaseNumber = this.goToCaseLandingPageByCaseNumber.bind(this);
    this.setSummaryData = this.setSummaryData.bind(this);
    this.attachAndArchive=this.attachAndArchive.bind(this);
    this.toggleFilterPane = this.toggleFilterPane.bind(this);
    this.handleApplyFilters = this.handleApplyFilters.bind(this);
    this.closeFilterPane = this.closeFilterPane.bind(this);
    this.resetFilterValues = this.resetFilterValues.bind(this);
    this.prepopulateImageDate = this.prepopulateImageDate.bind(this);
    this.fetchSchemeImageData = this.fetchSchemeImageData.bind(this);
    this.fetchMerchantImageData = this.fetchMerchantImageData.bind(this);
    this.convertOcrMapping = this.convertOcrMapping.bind(this);
    this.handleSearchResults = this.handleSearchResults.bind(this);
    this.showBanner = this.showBanner.bind(this);
    this.updateSelectedPages = this.updateSelectedPages.bind(this);
    this.updateSelectedFlag = this.updateSelectedFlag.bind(this);
    this.getQueueImageData = this.getQueueImageData.bind(this);
    this.getImageContent = this.getImageContent.bind(this);
    this.attachSelectedCase = this.attachSelectedCase.bind(this);
    this.closeBanner = this.closeBanner.bind(this);
    this.handleTakeActionClick = this.handleTakeActionClick.bind(this);
    this.handleBackToQueueClick= this.handleBackToQueueClick.bind(this);
    this.undoImageLinking = this.undoImageLinking.bind(this);
    // this.currentImageIndex = this.currentImageIndex.bind(this);
    this.updateSelection = this.updateSelection.bind(this);
    this.goToImageLanding = this.goToImageLanding.bind(this);
    this.toggleSelections = this.toggleSelections.bind(this);
    this.getTokenFromCardNumber = this.getTokenFromCardNumber.bind(this);
    this.getImageFilterData = this.getImageFilterData.bind(this);
    this.checkIfLocked = this.checkIfLocked.bind(this);
    this.openDocument = this.openDocument.bind(this);
    this.downloadDocument = this.downloadDocument.bind(this);
    this.updatePageList = this.updatePageList.bind(this);
    this.updateCurrentSelectedImageIndex = this.updateCurrentSelectedImageIndex.bind(this);
    this.updatedSummaryData = this.updatedSummaryData.bind(this);
    this.fetchDocumentLabel = this.fetchDocumentLabel.bind(this);
  }

  updatedSummaryData(updatedSummaryData) {
    this.setState({updatedSummaryData});
  }

  updateCurrentSelectedImageIndex(index) {
    
    this.setState({
      currentSelectedImageIndex: index
    });
  }

  attachAndArchive(attachAndArchive){
    let imageDataArray=[];
    let validationRequired = false;
    let requestEntityTooLarge = false;

    attachAndArchive.map((data)=>{
      if(data.documentLabel == undefined || data.documentLabel == null || data.documentLabel == ''){
        data.assignedLabelValidate = true;
        data.spiningLogo = false;
      }
    });

    if(attachAndArchive.some(caseRow=>caseRow.documentLabel == undefined && caseRow.clear == false))
        validationRequired = true;
    
    if(!validationRequired){
      attachAndArchive.map((data)=>{
        this.setState({isLoad:!this.state.isLoad});
        let pageContentsArr = data.pages.map(page => {
          return {
            ...page,
            pageContent: ''
          }
        });
        let imageData = {};
        if(data.clear==false && (data.isAttachSuccess==null || data.isAttachSuccess==false)){
        imageData.stageId=data.caseStageId;
        imageData.caseNumber=data.caseNbr;
        imageData.imageContents=pageContentsArr;
        imageData.sortingIndicator = false;
        imageData.documentLabel=data.documentLabel;
        if(data.documentLabel !== undefined && (data.isAttachSuccess==null || data.isAttachSuccess==false)) data.spiningLogo=true;
        imageDataArray=imageDataArray.concat(imageData);
        }
      });

      let attachPayload = {
        imageContentList : this.state.updatedPageList.map(pageList => pageList.pageContent),
        archiveInfo: imageDataArray
      }

      attachAndArchiveImage(this.props.location.state.data.documentId,attachPayload)
        .then((apiResponse) => {
          if(apiResponse === 413) {
            requestEntityTooLarge = true;
          }
          if(apiResponse.status.statusCode === 2000 || apiResponse.status.statusCode === 200) {
            flushSync(() => {
              this.setState({
                attachAndArchiveList: apiResponse.data,
                isLoading: true,
              });
            });
          }
          if (this.state.attachAndArchiveList.failureCases.length === 0 && this.state.attachAndArchiveList.successCases.length >=1   ) {           
              this.setState({
                showAttachSuccessBanner: true, 
              });
          }
          attachAndArchive.map((data,index)=>{
            data.spiningLogo=false;
            if(this.state.attachAndArchiveList.successCases.some(caseRow=>caseRow==data.caseNbr))
            data.isAttachSuccess = true;
            if(this.state.attachAndArchiveList.failureCases.some(caseRow=>caseRow==data.caseNbr))
            data.isAttachSuccess=false; 

          });
          this.setState({isLoad:!this.state.isLoad});
        }).catch((error) => {
          console.log('Error Occured while fetching case details', error);
          if (requestEntityTooLarge) {
            attachAndArchive.map((data)=>{
              data.isAttachSuccess = false;
              data.spiningLogo = false;
            });
            this.setState({
              showBaseErrorBanner: true,
              isLoading: false,
            });
          } else {
            this.setState({
              showErrorBanner: true,
              isLoading: false,
            });
          }
        });
  }else{
    this.setState({isLoad:!this.state.isLoad});
  }

  }
  setSummaryData(summaryData,isAssignPages) {
    this.setState({
      summaryData,
      isAssignPages

    });
  }

  handleSelect = () => {
    this.setState({ selected: !this.state.selected });
  }

  toggleSelections = () => {
    this.setState({
      isSelections: !this.state.isSelections,
    });
  }

 
  getImageContent(documentDirectoryPath, documentName) {

    getImageContent(documentDirectoryPath, documentName)
      .then((apiResponse) => {
        const imageContents = apiResponse.data;
        let updatedPageList = [];
        imageContents.forEach((image, imageIndex) => {
          updatedPageList = updatedPageList.concat({ pageId: imageIndex, pageContent: image });
        });
        this.setState({
          imageContents,
          imageContentsErr: false,
          updatedPageList,
          isImageDataLoading: false,
        }
          , () => {
            postLockImage(this.props.location?.state?.data?.documentId)
              .then((lockApiResponse) => {
                this.setState({
                }, () => {
                  if (!lockApiResponse.data.isCaseLocked) {
                    setLockedImages(this.props.location?.state?.data?.documentId);
                  }
                });

                setLockedImageCount(lockApiResponse.data.lockedCaseCount);
                if (lockApiResponse.data.isCaseLocked === true) {
                  const notificationContent = <div style={{ color: 'black' }}>
                    <b>Read Only Mode.</b>
                    <p>This image is currently being worked by {lockApiResponse.data.userName}</p>
                  </div>
                  this.onReadOnly(notificationContent);
                }
                this.setState({
                  userName: lockApiResponse.data.userName,
                  isReadOnly: lockApiResponse.data.isCaseLocked,
                });

              })
              .catch((error) => {
                this.setState({
                  isLoading: false,
                })
                if (error.response && error.response.status === 412) {
                  this.setState({
                    emptyStateHeading: 'Maximum Tab Limit Reached!',
                    emptyStateDescription: 'You cannot work on more than 10 Images at once!',
                    tabLimitExceed: true,
                  });
                }
                console.log('Error Occured while locking the image', error);
              });
          });
      })
      .catch((error) => {
        console.log('Error Occured while fetching image contents from selected file', error);
        this.setState({
          imageContentsErr: true,
          isImageDataLoading: false,
          imageContents: [],
        });
      });
  }

  toggleFilterPane() {
    document.body.classList.add('instant-header');

    const mainContent = document.getElementsByClassName('main-content');
    mainContent[0].scrollTop = 0;

    this.setState(
      {
        isFilterVisible: !this.state.isFilterVisible,
      },
    );
  }

  closeFilterPane = () => {
    this.setState({ isFilterVisible: false });
  };

  resetFilterValues() {
    this.setState({
      currentValues: [],
    });
  }
  closeBanner() {
    this.setState({
      showSuccessBanner: false,
      showErrorBanner: false,
      showBaseErrorBanner: false,
      showUndoErrorBanner: false,
      showUndoSuccessBanner: false,
      archiveImageFailBanner: false,
      showAttachSuccessBanner:false,
    });
  }
  handleApplyFilters(newValues) {
    this.closeFilterPane();
    let resultString = '';
    let isAccountNumber = false;
    let accountNumberValue = "";
    newValues.forEach((filterValue) => {
      // eslint-disable-next-line no-restricted-syntax
      for (const field in filterValue) {
        if (filterValue[field] !== '') {
          if (field === 'transactionDate') {
            // TODO: Unit testing needed once value from filter are selected.
            if (filterValue[field].v2 === undefined) { resultString = `${resultString}fromDate=${filterValue[field].v1}&`; } else {
              filterValue[field].v1 = moment(filterValue[field].v1).format('YYYY-MM-DD');
              filterValue[field].v2 = moment(filterValue[field].v2).format('YYYY-MM-DD');

              resultString = `${resultString}fromDate=${filterValue[field].v1}&`;
              resultString = `${resultString}toDate=${filterValue[field].v2}&`;
            }
          } else if (field === 'cardNumberRk') {
            if (filterValue[field].v1 && filterValue[field].v1 != '') { resultString = `${resultString}firstSixcardNumber=${filterValue[field].v1}&` };
            if (filterValue[field].v2 && filterValue[field].v2 != '') { resultString = `${resultString}lastFourCardNumber=${filterValue[field].v2}&` };
          } else if (field === 'accountNumber') {
            isAccountNumber = true;
            accountNumberValue = filterValue[field].v1;
          } else {
            resultString = `${resultString}${FILTER_API_MAPPING[field]}=${filterValue[field].v1}&`;
          }
        }
      }
    });

    if(!isAccountNumber)
    {
      let acquirerAccessList=getAcquirerAccessList();
      resultString = `${resultString}acquirerlist=${acquirerAccessList}`;
    }

    isAccountNumber ? this.getTokenFromCardNumber(accountNumberValue, resultString) : this.getImageFilterData(resultString);
    this.setState({ currentValues: newValues });
  }

  getImageFilterData(resultString) {
    postFilterImageValues(resultString)
      .then((apiResponse) => {
        let formattedList = this.getQueueImageData(apiResponse.data);
        this.setState({
          ImageList: formattedList,
          ImageListError: false,
          addClass: true,
        });
      })
      .catch((error) => {
        console.log('Error Occured while fetching case details', error);
        this.setState({
          ImageList: [],
          addClass: true,
          ImageListError: true,
        });
      });

  }

  getTokenFromCardNumber(cardNumber, resultString) {
    return getToken(cardNumber)
      .then((apiResponse) => {
        if (apiResponse.status.statusCode === 2000) {
          this.setState({
            caseDataErr: false,
            isLoading: false,
          })
          resultString += `globalToken=${apiResponse.data.GlobalToken}&`
          this.getImageFilterData(resultString);
        }
      })
      .catch((error) => {
        this.setState({ caseDataErr: true, isLoading: false });
        console.log('Error Occured while tokenizing Card Number', error);
      });

  }
  renameObjectKeys(index, obj1) {
    let prepend;
    switch (index) {
      case 1:
        prepend = 'caseDetail_';
        break;
      case 2:
        prepend = 'caseStageDetail_';
        break;
      default:
        return;
    }
    if (obj1 == null) { return obj1; }
    Object.keys(obj1).forEach((key) => {
      const new_key = prepend + key;
      obj1[new_key] = obj1[key];
      delete obj1[key];
    });
    return obj1;
  }
  handleSearchResults() {
    this.setState({
      addClass: !this.state.addClass,
      isZoomReset: true,
     });
  }
  goBack = () => {
    if (this.props.location.state !== undefined) {
      this.props.history.goBack();
    }
  };

  resetScrollPos() {
    this.setState({
      scrollPos: 0,
    });
  }

  checkIfLocked(summaryContent, selectedIndex) {
    checkIfLocked(this.state.ImageList[selectedIndex].caseDetail_caseNumber, this.state.ImageList[selectedIndex].caseStageDetail_caseStageId)
      .then((apiResponse) => {
        if (apiResponse.data.isCaseLocked === true) {
          let ImageListArray = this.state.ImageList;
          ImageListArray[selectedIndex].isCaseLocked = true;
          ImageListArray[selectedIndex].userName = apiResponse.data.userName;
          this.setState({ ImageList: ImageListArray })
        }
        else {
          this.attachSelectedCase(summaryContent, selectedIndex);
        }
      })
      .catch((error) => {
        if (error.response.status === 404 || error.response.status.statusCode === 4004) {
          this.attachSelectedCase(summaryContent, selectedIndex);
        }
        else {
          this.setState({
            showCaseLockedMessage: false,
            isLoading: false,
          })
        }
      })

  }
  attachSelectedCase(summaryContent, selectedIndex) {
    let ImageListArray = this.state.ImageList;
    ImageListArray[selectedIndex].isCaseLocked = false;
    let allSelectedPages = [];
    this.setState({
      selectedIndex,
      ImageList: ImageListArray,
      showCaseLockedMessage: false,
    });
    let actionValue = '';
    let displayText = 'Pages';
    let userSelectedPages = [];

    this.state.selectedPages.forEach((page) => {
      this.state.updatedPageList.map((UpdatedPage) => {
        if (UpdatedPage.pageId == page.pageId)
          allSelectedPages = allSelectedPages.concat({ ...UpdatedPage, isSelected: true, addedWhen: Date.now() + page.pageId, });
      })
      userSelectedPages = userSelectedPages.concat(page.pageId + 1);
    });
    this.setState({
      selectedPages: allSelectedPages,
    })
    const sortedPageList = userSelectedPages.sort((a, b) => {
      return a > b;
    });
    for (let index = 0; index < sortedPageList.length; index++) {
      if (sortedPageList.length === 1) {
        displayText = 'Page';
      }
      const ampAdded = index === sortedPageList.length - 1 && index !== 0 ? '&' : '';
      const comma = index !== sortedPageList.length - 2 && index !== sortedPageList.length - 1 && index >= 0 ? ',' : '';
      displayText = `${displayText} ${ampAdded} ${sortedPageList[index]} ${comma}`;
    }
    displayText = `${displayText} `;
    actionValue = `Case #${this.state.ImageList[selectedIndex].caseDetail_caseNumber}`;

    const imagedataToAttach = {};
    imagedataToAttach.imageContents = this.state.selectedPages;
    imagedataToAttach.sortingIndicator = false;
    this.setState({
      isAttachStarted: true,
    })
    attachImage(this.state.ImageList[selectedIndex].caseStageDetail_caseStageId, this.state.ImageList[selectedIndex].caseDetail_caseNumber, this.props.location.state.data.documentId, imagedataToAttach)
      .then((apiResponse) => {
        this.setState({
          attachList: apiResponse.data,
          showSuccessBanner: true,
          displayText,
          attachListError: false,
          isLoading: true,
          actionValue,
          isAttachStarted: false,
        });
      }).catch((error) => {
        console.log('Error Occured while fetching case details', error);
        this.setState({
          attachList: [],
          showErrorBanner: true,
          attachListError: true,
          isAttachStarted: false,
        });
      });
  }
  goToCaseLandingPageByCaseNumber(summaryContent, selectedIndex){

    gotoNewTabCaseLandingPage(this.state.ImageList[selectedIndex].caseDetail_caseNumber);

  }
  goToCaseLandingPage() {
    this.props.history.push({
      state: {
        data: this.props.location.state.data,
        prevPath: this.props.location.pathname,
      },
      pathname: `/caselanding/${this.state.ImageList[this.state.selectedIndex].caseDetail_caseNumber}`,
    });
  }
  handleTakeActionClick() {
    this.goToCaseLandingPage();
  }
  handleBackToQueueClick(){
    if(this.props.location.state.data.regionCode == 'UK'){
      this.props.location.state.queueId == 15 ? this.props.history.push(`/queue/${this.props.location.state.queueId}?regionCode=EU&hideBaseQueueDropdown=true`) : this.props.history.push(`/queue/${this.props.location.state.queueId}?hideBaseQueueDropdown=true`);
    }
    else{
      if(this.props.location.state.data.documentName.includes("HPY."))
      {
        this.props.location.state.queueId == 15 ? this.props.history.push(`/queue/${this.props.location.state.queueId}?regionCode=${'HPY'}&hideBaseQueueDropdown=true`) : this.props.history.push(`/queue/${this.props.location.state.queueId}?hideBaseQueueDropdown=true`);
      }else{
        this.props.location.state.queueId == 15 ? this.props.history.push(`/queue/${this.props.location.state.queueId}?regionCode=${this.props.location.state.data.regionCode}&hideBaseQueueDropdown=true`) : this.props.history.push(`/queue/${this.props.location.state.queueId}?hideBaseQueueDropdown=true`);
      }
    
    }
  }
  showBanner() {
    const successMsg = " have been successfully attached to";
    const descriptionHtml = (
      <div>
        {this.state.displayText}
        from&nbsp;
        <b style={{ wordBreak: 'break-word' }}>
          {this.props.location.state.data.documentName}
        </b>{successMsg}
        <b>&nbsp;
          {this.state.actionValue}
        </b>
        .
      </div>
    );
    const undoDescription = (
      <div>
        Document&nbsp;
        <b style={{ wordBreak: 'break-word' }}>
          {this.props.location.state.data.documentName}
        </b>
        &nbsp;has been successfully unlinked.
      </div>
    );
    const attachSuccessDescriptionHtml = (

      <div>
        All assigned pages from&nbsp;<br/>
        <b style={{ wordBreak: 'break-word' }}>
          {this.props.location.state.data.documentName}
        </b>&nbsp;have been attached successfully.
        <b>
        </b>
      </div>
    );
    return (
      <div>
        {this.state.showAttachSuccessBanner && (
          <ImagePortal>
          <ResponseBanner
            titleStyle={{ color: 'light-green' }}
            descriptionStyle={{ color: 'grey' }}
            valueStyle={{ color: 'black' }}
            title="Success!"
            description={attachSuccessDescriptionHtml}
            type="success"
            successOnly={true}
            primaryButtonText="Back to Queue"
            onClose={this.handleBackToQueueClick}
            primaryButtonAction={this.handleBackToQueueClick}
          />
          </ImagePortal>
        )}
        {this.state.showSuccessBanner && (
           <ImagePortal>
          <ResponseBanner
            titleStyle={{ color: 'light-green' }}
            descriptionStyle={{ color: 'grey' }}
            valueStyle={{ color: 'black' }}
            title="Success!"
            descriptionHtml={descriptionHtml}
            type="success"
            undoButton
            extraButtonText="UNDO"
            extraButtonAction={this.undoImageLinking}
            primaryButtonText="OPEN CASE"
            cancelButtonText="CONTINUE EDITING IMAGE"
            onClose={this.closeBanner}
            isSecondaryButton
            isSecondaryButtonActive=""
            secondaryButtonAction=""
            primaryButtonAction={this.handleTakeActionClick}
          />
           </ImagePortal>
        )}
        {this.state.showUndoSuccessBanner && (
           <ImagePortal>
          <ResponseBanner
            titleStyle={{ color: 'light-green' }}
            descriptionStyle={{ color: 'grey' }}
            valueStyle={{ color: 'black' }}
            title="Success!"
            descriptionHtml={undoDescription}
            type="success"
            noActions
            onClose={this.closeBanner}
          />
           </ImagePortal>
        )}
        {this.state.showErrorBanner && (
          <ImagePortal>
          <ResponseBanner
            title="Error !"
            description="Error"
            type="danger"
            cancelButtonText="CANCEL"
            onClose={this.closeBanner}
          />
          </ImagePortal>
        )}
        {this.state.showBaseErrorBanner && (
          <ImagePortal>
            <ResponseBanner
              title="Error !"
              description="Request too large !!"
              type="danger"
              cancelButtonText="CANCEL"
              onClose={this.closeBanner}
            />
          </ImagePortal>
        )}
        {this.state.showUndoErrorBanner && (
           <ImagePortal>
          <ResponseBanner
            title="Error !"
            description="System Error: Unable to unlink the image/document."
            type="danger"
            noActions
            onClose={this.closeBanner}
          />
           </ImagePortal>
        )}
        {this.state.archiveImageFailBanner && (
        <ImagePortal>
          <ResponseBanner
            title="Error !"
            description="System Error: Unable to archive image."
            type="danger"
            cancelOnly
            cancelButtonText="DISMISS"
            onClose={this.closeBanner}
          />
           </ImagePortal>
        )}
      </div>
    );
  }

  updateSelectedPages(selectedPages) {
    this.setState({
      selectedPages,
    });
  }

  updateSelectedFlag(selectAllFlag) {
    this.setState({
      selectAllFlag,
    });
  }
  getQueueImageData(responseData) {
    const arr = [];
    responseData.forEach((obj) => {
      arr.push(Object.assign(this.renameObjectKeys(1, cloneDeep(obj.caseDetail)),
        this.renameObjectKeys(2, cloneDeep(obj.caseStageDetail)), obj, { isCaseLocked: false, userName: '' }));
    });

    return arr;
  }

  refactorDataToDisplay(data) {
    const result = {};
    data.forEach((obj) => {
      for (const key in obj) {
        if (key === 'caseNumber' || key === 'cardBrandCaseNumber') {
          result[`${key}`] = obj[key].v1;
        }
      }
    });
    return result;
  }

  updateSelection() {
    const data = {
      documentId: this.props.location.state.data.documentId,
    };
    this.props.archiveImage(data);
  }

  goToImageLanding() {
    this.goBack();
  }

  setArchiveImageBanner(archiveData) {
    const responseBannerContent = (
      <div>
        <div>
          <b style={{ wordBreak: 'break-word' }}>{this.props.location.state.data.documentName}</b>
          {' '}
          <span>{archiveData.bannerResponseMessage}</span>
          .
        </div>
      </div>
    );

    this.props.location.state.setNotification([{
      title: 'Image Archived',
      type: 'success',
      titleStyle: "color: 'light-green'",
      descriptionHtml: responseBannerContent,
      cancelOnly: true,
      cancelButtonText: 'DISMISS',
      primaryButtonText: 'ARCHIVED',
    }]);
  }

  updatePageList(updatedPageList) {
    this.setState({
      updatedPageList
    });
  }

  openDocument() {
    openDocumentInNewTab(this.state.updatedPageList, this.props.location.state.data.documentName);
  }

  downloadDocument() {
    this.setState({
      downloadInProgress: true,
    }, () => {
      return apiDownloadDocument(this.state.updatedPageList, this.props.location.state.data.documentName)
        .then(response => {
          const blob = new Blob([response], { type: 'application/octet-stream' });
          fileSaver.saveAs(blob, this.props.location.state.data.documentName);
          this.setState({
            downloadInProgress: false,
          });
        })
        .catch(error => {
          console.log('Unable to download the file: ', error);

          const notificationMessageError = {
            type: 'error',
            placement: 'topRight',
            messageWidth: 250,
            byDefault: true,
            duration: 5,
            content: <div style={{ color: 'black', paddingTop: 10 }}>
              <b>System Error</b>: Unable to download selected document.
              </div>
          };
          openNotificationToast(notificationMessageError);
          this.setState({
            downloadInProgress: false,
          });
        });
    })
  }

  fetchDocumentLabel(uiDocTypeListCode) {
    getDocumentTypeUrl(uiDocTypeListCode).then((response) => {
      this.setState({
        documentTypes: response.data
      });
    }).catch((error) => {
      console.log('Error occured while fetching Document Label Types', error);
    });
  }

  onReadOnly = (notificationContent) => {
    const notificationMessageSuccess = {
      type: 'info',
      placement: 'topRight',
      messageWidth: 250,
      byDefault: true,
      duration: 10,
      content: notificationContent,
    };
    return openNotificationToast(notificationMessageSuccess);
  }

  unlockCurrentImage = () => {
    return unlockImage(this.props.location?.state?.data?.documentId)
      .then((apiResponse) => {
        let tabNumber = getLockedImageCount();
        tabNumber--;
        tabNumber >= 0 && setLockedImageCount(tabNumber);
        this.setState({
          isReadOnly: apiResponse.data,
        });
      })
      .catch((error) => {
        console.log('Error Occured while Un-locking the case', error);
      });
  }

  removeCurrentLockedImage = () => {
    if (this.props.isUserAuthenticated) {
      removeLockedImages(this.props.location?.state?.data?.documentId);
    }
  }

  updateCurrentImageTimeStamp = () => {
    if (!this.state.isReadOnly && this.props.location?.state?.data?.documentId) {
      postLockImage(this.props.location?.state?.data?.documentId)
        .then((lockApiResponse) => {
          console.log("Time stamp update for current documentId", this.props.location?.state?.data?.documentId);
        })
        .catch((error) => {
          console.log("Error occured while update locked documentId: ", error);
        });
    }
  }

  render() {
    window.document.title = 'Image Selection';
    const filterPaneTriggerClasses = classnames('filter-pane-trigger', {
          'is-disabled': this.state.isReadOnly,
          'opacity': this.state.isReadOnly && '0.5',
        });
    let wrapperClass;

    if (this.props.location.state !== undefined) {
      wrapperClass = classnames('image-selection', {
        'is-disabled': false,
        'opacity': this.props.imageSelection.isArchiving && '0.2',
      });
    }
    return (
      this.props.location.state ? (
        <div>
          {this.showBanner()}

          {
            (this.state.isImageDataLoading) && <BVLoader20 />
          }
          {
            (this.props.imageSelection.isArchiving) && <BVLoader20 centerAlign={true}/>
          }
          {
            (<div className={wrapperClass}>
              <div className="main-content--header">
                <div className="flex-left image-selection__name">
                  {this.state.isReadOnly &&
                    <div className="lockedCaseIcon">
                      <img alt="lockicon" className="lockIcon" src={LockIcon} height="20px" width="15px" />
                    </div>
                  }
                  <div className='image-selection__name-back'>
                    <LinkInlineButton action={this.handleBackToQueueClick}>
                      <LeftPointerIcon /> { counterpart('globalTranslate.queues.backToImageQueue') }
                    </LinkInlineButton>
                  </div>
                  <div>
                    <EditableInput
                      extraClass="report-builder"
                      label="Attach Document to Case"
                      content={this.props.location.state.data.documentName}
                      placeholder="Attach Document to Case"
                      sizeLabel="File Size"
                      sizeContent={this.props.location.state.data.documentSize}
                      readOnly
                      hideOpenDocButton={true}
                      getCurrent={()=>{}}
                    />
                  </div>
                </div>
                {this.state.imageContents.length > 0 && <div className="flex-right" style={{ paddingRight: 13 }}>
                  <div className="open-doc">
                    <OpenNewWindowIcon
                      onClick={this.openDocument}
                      height={20}
                      width={20}
                    />
                  </div>
                  {!this.state.downloadInProgress && this.props.user.parsedPermissions.document && this.props.user.parsedPermissions.document.download
                    && <div className="open-doc">
                      <DownloadIcon
                        onClick={this.downloadDocument}
                        height={20}
                        width={20}
                      />
                    </div>}
                  {
                    this.state.downloadInProgress &&
                    <div className="document-loading">

                      <ChangingProgressProvider
                        values={[12, 20, 48, 52, 57, 63, 69, 72, 77, 83, 88, 93, 100]}
                        pauseValue={93}
                      >
                        {percentage => (
                          <CircularProgressbar value={percentage} text={`${percentage}%`}
                            styles={buildStyles({
                              pathColor: COLORS.oneGp.globalBlue,
                              textColor: COLORS.oneGp.globalBlue,
                              textSize: "25px"
                            })} />
                        )}
                      </ChangingProgressProvider>
                    </div>
                  }
                  <div
                    role="button"
                    tabIndex={0}
                    id="UnmatchedImage_filter_btn"
                    className={filterPaneTriggerClasses}
                    onClick={!this.state.isReadOnly && this.toggleFilterPane}
                    aria-expanded={this.state.isFilterVisible}
                    onKeyDown={!this.state.isReadOnly && this.toggleFilterPane}
                  >
                    <span className="gd-report-runner__filter-toggle">Search Cases</span>
                  </div>


                  <div style={{ paddingLeft: 13 }}>
                    <SelectInput
                      dataList={this.state.selectList}
                      selectClass={{
                        color: '#007dc3',
                        marginLeft: '-73px',
                        height: '50px',
                        padding: 6,
                        overflow: 'hidden',
                      }}
                      action={() => { this.submitActionForm(this.props.selectedActionPanelDetailItem); }}
                      handleSelection={this.updateSelection}
                      promptText="Take Action"
                      wrapperClass="select-menu__form reports"
                      promptOnly
                      isAppSelection
                      selectedItem={this.state.selectedItem}
                      type="withIcon"
                      isArchiveImage
                      isReadOnly={this.state.isReadOnly}
                      classExtension={this.state.isReadOnly ? "img-lock-css" : ""}
                    />
                  </div>
                </div>}
              </div>
              {this.state.imageContents.length > 0 && <div className="main-content--wrapper">
                {this.state.isFilterVisible && (
                  <div className="gd-filter-pane__wrapper">

                    <GDFilterPane
                      applyFilters={this.handleApplyFilters}
                      closeFilterPane={this.closeFilterPane}
                      currentValues={this.state.currentValues}
                      dateFormat="MM/DD/YYYY"
                      filterList={this.props.location.state.imageSelectionConfig.searchFilters}
                      isVisible={this.state.isFilterVisible}
                      reportName="UnmatchedImages_filterPane"
                      data={this.props.location.state.data}
                      resetValues={this.resetFilterValues}
                      translations={getFilterTranslations()}
                    />
                  </div>
                )}
                <div className={this.state.addClass === true ? 'image-view' : 'wide-view-image'}>
                  <ImageToolkit
                    type={this.props.location.state.queueId}
                    updateParentSelectedPages={this.updateSelectedPages}
                    imageContents={this.state.imageContents}
                    imageContentsErr={this.state.imageContentsErr}
                    summaryData={this.state.summaryData}
                    updateFlag={this.state.addClass}
                    addClass={this.state.addClass}
                    selectedPages={this.state.selectedPages.filter(page => (page.isSelected === true))}
                    isSelectedFlag={this.updateSelectedFlag}
                    pageselectormodal='pageselectorimageselectionnomodal'
                    updatePageList={this.updatePageList}
                    isModal={false}
                    navCollapsed={this.props.navCollapsed}
                    updateCurrentSelectedImageIndex={this.updateCurrentSelectedImageIndex}
                    isReadOnly={this.state.isReadOnly}
                    zoomReset={this.state.isZoomReset}
                  />
                </div>
                <div className={this.state.addClass ? 'image-details' : 'hide-details '}>
                  <div role="button" tabIndex={0} onKeyDown={!this.state.isReadOnly && this.handleSearchResults} onClick={!this.state.isReadOnly && this.handleSearchResults} className={this.state.isReadOnly ? "side-arrow-readOnly" : "side-arrow"}><img className="tab-arrow-icon" src={tabArrow} /></div>
                  {
                    this.state.addClass && (
                      <>
                        {this.state.isAssignPages && this.state.summaryData.some(row => row.clear == false) &&
                          <ImageSearchResultAssignmentSummary
                            type={this.props.location.state.queueId}
                            summaryPanel={this.props.location.state.caseSelectionConfig.imageSearchResultsPanel.assignColumns}
                            searchContent={this.state.ImageList}
                            attachSelectedCase={this.checkIfLocked}
                            goToCaseLandingPageByCaseNumber={this.goToCaseLandingPageByCaseNumber}
                            attachAndArchive={this.attachAndArchive}
                            summaryData={this.state.summaryData}
                            isAssignPages={this.state.isAssignPages}
                            selectedPages={this.state.selectedPages.filter(page => (page.isSelected === true))}
                            currentSelectedImageIndex={this.state.currentSelectedImageIndex}
                            updatedSummaryData={this.updatedSummaryData}
                            documentTypes={this.state.documentTypes}
                          />
                        }
                        <ImageSearchResults
                          type={this.props.location.state.queueId}
                          searchPanel={this.props.location.state.caseSelectionConfig.imageSearchResultsPanel.summaryColumns}
                          summaryPanel={this.props.location.state.caseSelectionConfig.imageSearchResultsPanel.assignColumns}
                          searchContent={this.state.ImageList}
                          attachSelectedCase={this.checkIfLocked}
                          goToCaseLandingPageByCaseNumber={this.goToCaseLandingPageByCaseNumber}
                          setSummaryData={this.setSummaryData}
                          attachAndArchive={this.attachAndArchive}
                          summaryData={this.state.summaryData}
                          pageList={this.state.updatedPageList}
                          isAssignPages={this.state.isAssignPages}
                          selectedPages={this.state.selectedPages.filter(page => (page.isSelected === true))}
                          dateFormat={this.props.location.state.caseSelectionConfig.dateFormat}
                          currentImageIndex={this.currentImageIndex}
                          selectAllFlag={this.state.selectAllFlag}
                          isAttachStarted={this.state.isAttachStarted}
                          user={this.props.user}
                          isMerchantPortal={false}
                          currentSelectedImageIndex={this.state.currentSelectedImageIndex}
                          updatedSummaryData={this.updatedSummaryData}
                        />
                        <ImageData
                          dataPanel={this.props.location.state.caseSelectionConfig.imageSearchDataPanel.summaryColumns}
                          dataContent={this.refactorDataToDisplay((this.state.readOnlyCurrentValues))}
                        />
                      </>
                    )}
                </div>
              </div>
              }
            </div>
            )}
          {
            !this.state.isImageDataLoading &&
            this.state.imageContentsErr && (
              <EmptyState
                translations={{ emptyStateHeading: this.state.emptyStateHeading, emptyStateDescription: this.state.emptyStateDescription }}
              />
            )

          }
        </div>
      ) : <Redirect path="*" to="/" />

    );
  }
}


ImageSelection.propTypes = {

};

ImageSelection.defaultProps = {
  extraClass: 'some-class',

};
function getSelectionList() {
  return [

    { id: '1', value: 'archiveImage', text: 'Archive Image' },
  ];
}
const  mapStateToProps = (state) => ({
  user: state.auth.user,
  isUserAuthenticated: isUserAuthenticatedSelector(state),
  imageSelection: state.imageSelection
});

const mapDispatchToProps = (dispatch) => {
  return {
    archiveImage: (documentInfo) => {
      dispatch(archiveImage(documentInfo));
    },
    initializeImageSelection: () => {
      dispatch(initializeImageSelection());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ImageSelection);